import React, {useEffect} from 'react';
import block from 'bem-cn-lite';
import {ToasterComponent, ToasterProvider} from '@gravity-ui/uikit';
import {Outlet} from 'react-router-dom';
import {hideTalkMeWidget} from 'widgets';

import './Wrapper.scss';

const b = block('wrapper');

export const Wrapper: React.FC = () => {
    useEffect(() => {
        // скрываем виджет чата TalkMe для неавторизованных
        hideTalkMeWidget();
    }, []);

    return (
        <ToasterProvider>
            <div className={b()}>
                <Outlet />
            </div>
            <ToasterComponent />
        </ToasterProvider>
    );
};
